import styled from "styled-components";

export const Wrapper = styled.div`
  .datefilter{
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius:10px;
    min-width: 220px;
  }

  .status-column{
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    justify-content: center;
    min-width: 100px;
  }

  .edit-column{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    select{
      border: 1px solid rgba(0, 0, 0, .2);
      border-radius: 4px;
      background-color: white;
      height: 30px;
      outline: none;
    }
    img{
      width: 20px;
      height: 20px;
    }
  }
`;
